<template>
  <html>
    <head>
      <meta charset="utf-8" />
      <meta
        name="viewport"
        content="width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no"
      />
      <meta name="mobile-web-app-capable" content="yes" />
      <meta name="apple-mobile-web-app-capable" content="yes" />
      <link rel="icon" type="image/png" href="../assets/favicon.png" />
      <title>Restó APP</title>
    </head>
    <body class="login">
      <div class="d-flex align-items-center min-vh-100 bg-auth">
        <div class="container">
          <div class="justify-content-center row">
            <div class="my-5 col-xl-4 col-md-5 col-12">
              <h1 class="display-4 text-center mb-3">Crear cuenta</h1>
              <p class="text-muted text-center mb-5">
                Crea tu cuenta en Resto Line
              </p>
              <form v-on:submit.prevent="registrarse">
                <div class="form-group mb-3">
                  <label class="form-label">Nombre</label
                  ><input v-model="nombre" type="text" class="form-control" />
                </div>
                <div class="form-group mb-3">
                  <label class="form-label">Apellido</label
                  ><input v-model="apellido" type="text" class="form-control" />
                </div>
                <div class="form-group mb-3">
                  <label class="form-label">Email</label><br /><input
                    v-model="email"
                    type="text"
                    class="form-control"
                  />
                </div>

                <div class="form-group mb-3">
                  <label class="form-label">Repetir Email</label><br /><input
                    v-model="emailRepetir"
                    type="text"
                    class="form-control"
                  />
                </div>

                
                <div class="form-group mb-3">
                  <label class="form-label">Teléfono</label>
                  <VuePhoneNumberInput v-model="telefono" 
                  @update="resultsTelefono = $event"
                  default-country-code="AR"
                  :translations="{
  countrySelectorLabel: 'Código de país',
  countrySelectorError: 'Elige un país',
  phoneNumberLabel: 'Número de teléfono',
  example: 'Ejemplo :'
}" >
</VuePhoneNumberInput>
                </div>

                <div class="form-group mb-3">
                  <label class="form-label">Repetir Teléfono</label>
                  
                  <VuePhoneNumberInput v-model="telefonoRepetir" 
                  @update="resultsTelefonoRepetir = $event"
                  default-country-code="AR"
                  :translations="{
  countrySelectorLabel: 'Código de país',
  countrySelectorError: 'Elige un país',
  phoneNumberLabel: 'Número de teléfono',
  example: 'Ejemplo :'
}" >
</VuePhoneNumberInput>
                  
                </div>

                
                <div class="form-group mb-3">
                  <label class="form-label">Password</label
                  ><input
                    v-model="password"
                    type="password"
                    class="form-control"
                  />
                </div>
                <div class="form-group mb-5">
                  <label class="form-label">Repetir password</label
                  ><input
                    v-model="repeatPassword"
                    type="password"
                    class="form-control"
                  />
                </div>
                <div class="form-group mb-5">
                  <div class="form-check">
                    <input
                      v-model="terminos"
                      class="form-check-input"
                      type="checkbox"
                      id="checkTerms"
                    />
                    <label class="form-check-label" for="checkTerms">
                      Acepto los <a href="http://20.226.15.210:8081/terminos-condiciones" target="_blank">términos y conficiones</a>
                    </label>
                  </div>
                </div>

                <button type="submit" class="w-100 mb-3 btn btn-primary btn-lg">
                  Crear cuenta
                </button>
              </form>
              <PopUp :show="success_b" @close="success_b = false;">
                <template #body>
                  <p>{{ success_b_msg }}</p>
                </template>
              </PopUp>
              <PopUp :show="success" @close="success = false; goToPage('login')">
                <template #body>
                  <p>{{ success_msg }}</p>
                </template>
              </PopUp>
              <PopUp :show="error" @close="error = false">
                <template #body>
                  <p>{{ error_msg }}</p>
                </template>
              </PopUp>
            </div>
          </div>
        </div>
      </div>
    </body>
  </html>
</template>

<script>
import axios from "axios";
import PopUp from "../components/PopUp.vue";
import VuePhoneNumberInput from 'vue-phone-number-input';
import 'vue-phone-number-input/dist/vue-phone-number-input.css';

export default {
  name: "Register",
  components: { PopUp,VuePhoneNumberInput },
  data: function () {
    return {
      nombre: "",
      apellido: "",
      email: "",
      emailRepetir:"",
      telefono: null,
      telefonoRepetir: null,
      resultsTelefono:null,
      resultsTelefonoRepetir: null,
      password: "",
      repeatPassword: "",
      error: false,
      success: false,
      error_msg: "",
      success_msg: "",
      success_b_msg: "",
      success_b: false,
      terminos: [],
      token:"",
    };
  },

  beforeMount() {
    this.mostrarMensaje();
        this.token = new URLSearchParams(window.location.search).get('token')
     },
  methods: { 
    mostrarMensaje(){

      this.success_b = true;
      this.success_b_msg="Completa los siguientes campos para registrar un usuario. Con este usuario podrá crear una cuenta de tu establecimiento gastrónomico que contendrá toda la información necesaria para que los interesados en reservar una mesa elijan tu restaurante y así hacer crecer tu negocio.";

    },
    goToPage(page) {
      this.$router.push({ name: page });
    },
    registrarse() {
      this.error_msg = "";
      if(
      this.resultsTelefono != null && this.resultsTelefonoRepetir != null &&
     ( !this.resultsTelefono.isValid || !this.resultsTelefonoRepetir.isValid)
      
      ){
        this.error = true;
        this.error_msg = "Telefono invalido";
        return;
      }
      if (
        this.nombre == "" ||
        this.apellido == "" ||
        this.email == "" ||
        this.telefono == "" ||
        this.telefono == null ||
        this.password == "" ||
        this.repeatPassword == "" 
      ) {
        this.error = true;
        this.error_msg = "Completa todos los campos por favor";
        return;
      }

      if (this.terminos.length == 0) {
        this.error = true;

        this.error_msg =
          "Por favor tilda que has leido los terminos y condiciones";
        return;
      }

      if (this.email != this.emailRepetir) {
        this.error = true;

        this.error_msg = "Los correos no coinciden";
        return;
      }

      if (this.telefono != this.telefonoRepetir
      || 
      this.resultsTelefono.countryCallingCode != this.resultsTelefonoRepetir.countryCallingCode
      ) {
        this.error = true;

        this.error_msg = "Los telefonos no coinciden";
        return;
      }

      


      if (this.password != this.repeatPassword) {
        this.error = true;

        this.error_msg = "Las contraseñas no coinciden";
        return;
      }

      let json = {
        nombre: this.nombre,
        apellido: this.apellido,
        mail: this.email,
        telefono: this.resultsTelefono.formatInternational.trim().replace(/\s+/g, ''),
        password: this.password,
        rol: "2",
        token: this.token
      };
     

      axios
        .post("/registro-resto", json)
        .then((data) => {
          if (data.data.descripcionError == null) {
            this.success = true;
            this.success_msg = "Cuenta creada con exito. Verifique su email para poder activar la misma."
          } else {
            this.error = true;
            this.error_msg = data.data.descripcionError;
          }
        })
        .catch((e) => {
          this.error = true;
          if (e.request.status == 400) {
            this.error_msg = "No se ha podido realizar el registro";
          } else {
            this.error_msg = "No se ha podido realizar el registro";
          }
        });
    },

  },
};
</script>

<style scoped>
@import url("https://cdn.jsdelivr.net/npm/bootstrap@5.0.2/dist/css/bootstrap.min.css");
@import url("https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap");

:root {
  --main-color: #0047b3;
  --second-color: #0198f3;
  --grey-color: #f5f8fa;
  --border-radius-1: 9px;
  --border-radius-2: 6px;
}
body {
  font-family: "Inter", sans-serif;
  color: #083744;
  font-size: 14px;
  height: 100%;
}
</style>
